import { Outlet, createFileRoute } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { ArchiveOperationInstanceDialog } from '@/features/operation-instances/components/ArchiveOperationInstanceDialog';
import { Header } from './-components/Header';
import { useHeader } from './-hooks/useHeader';
import { getOperationPackageInstance } from './-query/api';
export const Route = createFileRoute('/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout')({
  loader: ({
    params
  }) => getOperationPackageInstance(params),
  component: RouteComponent
});
function RouteComponent() {
  const instance = Route.useLoaderData();
  const {
    actions,
    archiveDialog
  } = useHeader({
    instance
  });
  return <VStack>
      <Header instanceId={instance.id} packageId={instance.operationPackageId} packageName={instance.name} patternName={instance.patternName} tagName={instance.tag?.name} packageType={instance.packageType} requestedFor={[{
      name: instance.target.targetName,
      avatarUrl: instance.target.targetAvatarUrl
    }]} actions={actions} />
      <ArchiveOperationInstanceDialog isOpen={archiveDialog.isOpen} onClose={archiveDialog.onClose} onConfirm={archiveDialog.onConfirm} isPending={archiveDialog.isPending} />
      <Outlet />
    </VStack>;
}